<template>
  <v-container
  align-center
  fluid
  >
    <v-row justify="space-around">
      <v-col cols=8>
        <h1>About</h1>
        <p>
          Reddit Watch (Reddit Video Downloader) is a free online tool that lets you to download Reddit videos with audio.
          It can be used to save v.redd.it videos with sound directly to your computer or smartphone.
        </p>

      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data: () => ({
  }),
};
</script>
